(function ($, window) {
  const REGIONDO_BASE_URL = window.ecregiondo.globalsRegistered
    ? window.ecregiondo.API_VENDOR_URL : undefined;

  $('.navbar .cart-toggle').on('click', () => {

    if (window.ecregiondo && window.ecregiondo.globalsRegistered) {

      const cartUrl = `${REGIONDO_BASE_URL}checkout/cart/index`;
      const cartName = 'Regiondo Warenkorb';

      window.ecregiondo.showRegiondoWidget(cartUrl, cartName);
    }
  });

  /**
   * This inits coupon buttons within regiondo product list.
   */
  $('#regiondo-products').on('click', '.btn-coupon', function (e) {
    e.preventDefault();
    if (window.ecregiondo && window.ecregiondo.globalsRegistered) {

      const $item = $(this).closest('.product-item');
      const id = $item.data('id');
      const name = $item.data('name');
      const vendorid = window.ecregiondo.API_VENDOR_ID;

      const url = `${REGIONDO_BASE_URL}bookingwidget/vendor/${vendorid}/id/${id}/type/gift`;

      window.ecregiondo.showRegiondoWidget(url, name);

    }
  });
// set up collapsible elements
  $('#content').on('click', '.collapsible-head', function (e) {
    e.preventDefault();
    const $container = $(this).closest('.collapsible');
    const $body = $container.children('.collapsible-body');

    $body.stop(true).toggle(0, () => {
      $container.toggleClass('active', $body.is(':visible'));
      const $regiondoProducts = $('#regiondo-products');
      if ($regiondoProducts.length > 0) {
        $regiondoProducts.isotope('layout');
      }
    });
  });
// eslint-disable-next-line no-undef
}(jQuery, window));
